export default __webpack_public_path__ + "static/media/B-T-HTMATE.74c1703c.svg";